// src/components/NewJobView/Tabs/GeneralInfoTab.js

import React, { useState } from 'react';
import { PlusCircle, X } from 'lucide-react';

const GeneralInfoTab = ({ 
  jobData, 
  handleInputChange, 
  clients, 
  clientNameInput, 
  handleClientInputChange, 
  setIsClientModalOpen, 
  today, 
  handleCoverImageChange, 
  handlePaste
}) => {
  const [isImageMaximized, setIsImageMaximized] = useState(false);

  // The AI Prompt section has been removed from this component.
  // It is now handled by the dedicated AiPromptTab.js

  return (
    <>
      {isImageMaximized && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50 p-4"
          onClick={() => setIsImageMaximized(false)}
        >
          <button 
            className="absolute top-4 right-4 text-white hover:text-gray-300"
            onClick={() => setIsImageMaximized(false)}
          >
            <X size={32} />
          </button>
          <img 
            src={jobData.coverImage.preview} 
            alt="Vista maximizada" 
            className="max-h-[90vh] max-w-[90vw] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <div className="space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Information Column */}
          <div className="md:col-span-2 space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="client-input" className="text-sm font-bold text-gray-600 block mb-2">Cliente</label>
                <div className="flex items-center gap-2">
                  <input id="client-input" type="text" list="client-list" value={clientNameInput} onChange={handleClientInputChange} placeholder="Escribe para buscar..." className="w-full p-2 border border-gray-300 rounded-md" required />
                  <datalist id="client-list">
                    {(clients || []).map(client => <option key={client.id} value={client.name} />)}
                  </datalist>
                  <button type="button" title="Añadir nuevo cliente" onClick={() => setIsClientModalOpen(true)}>
                    <PlusCircle size={20} className="text-green-500 hover:text-green-600" />
                  </button>
                </div>
              </div>
              <div>
                <label htmlFor="jobName" className="text-sm font-bold text-gray-600 block mb-2">Nombre del Trabajo</label>
                <input type="text" name="jobName" id="jobName" value={jobData.jobName} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md" required />
              </div>
               <div>
                <label htmlFor="salesOrder" className="text-sm font-bold text-gray-600 block mb-2">Orden de Venta (ERP)</label>
                <input type="text" name="salesOrder" id="salesOrder" value={jobData.salesOrder} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md" />
              </div>
              <div>
                <label htmlFor="purchaseOrder" className="text-sm font-bold text-gray-600 block mb-2">Orden de Compra (PO)</label>
                <input type="text" name="purchaseOrder" id="purchaseOrder" value={jobData.purchaseOrder} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md" />
              </div>
            </div>
            <div className="md:col-span-2">
              <label htmlFor="description" className="text-sm font-bold text-gray-600 block mb-2">Descripción</label>
              <textarea name="description" id="description" rows="3" value={jobData.description} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md"></textarea>
            </div>
            <div>
                <label htmlFor="deliveryDate" className="text-sm font-bold text-gray-600 block mb-2">Fecha de Entrega</label>
                <input type="date" name="deliveryDate" id="deliveryDate" value={jobData.deliveryDate} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md" min={today}/>
            </div>
          </div>
          
          {/* Image Column */}
          <div className="md:col-span-1">
            <div
              className="border-dashed border-2 p-4 rounded-lg text-center h-full flex flex-col justify-center items-center"
              onPaste={(e) => handlePaste(e, handleCoverImageChange)}
            >
              <label className="text-sm font-bold text-gray-600 block mb-2">Imagen Principal</label>
              <div className="w-full h-96 flex items-center justify-center">
                  {jobData.coverImage.preview ? 
                      <img 
                        src={jobData.coverImage.preview} 
                        alt="Vista previa del producto" 
                        className="max-h-full max-w-full object-contain rounded-lg shadow-sm cursor-pointer hover:opacity-80 transition-opacity"
                        onClick={() => setIsImageMaximized(true)}
                      /> 
                      : <span className="text-gray-400">Sin imagen</span>
                  }
              </div>
              <input type="file" id="cover-image-input" className="hidden" accept="image/*" onChange={(e) => handleCoverImageChange(e.target.files[0])} />
              <label htmlFor="cover-image-input" className="mt-4 cursor-pointer text-sm font-medium text-blue-600 hover:text-blue-800">
                {jobData.coverImage.preview ? 'Cambiar Imagen' : 'Sube una imagen o pégala aquí'}
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralInfoTab;

